import {
  CreateMarketProductDto,
  MarketProductDto,
  PatchMarketProductDto,
} from '@careapp-group/ng-sdk';
import { CaEntityActionsFactory } from '../../../store/entity-state/entity-actions-factory';
import { MarketProductFilterType } from './market-products.reducer';

class MarketProductsActions extends CaEntityActionsFactory<
  MarketProductDto,
  CreateMarketProductDto,
  PatchMarketProductDto,
  MarketProductFilterType
> {
  constructor() {
    super('MarketProducts');
  }
}

export const MarketProductActions = new MarketProductsActions();
